import React, {useEffect, useState} from 'react';
import ScoreBoard from './Scoreboard';
import ProgressBar from './ProgressBar';
import SecurityExpertQ4 from './SecurityExpertQ4';
import CorrectAnswer from './CorrectAnswer';
import {useTranslation} from 'react-i18next';
import useGame from '../hooks/useGame';
import SkipVideo from './SkipVideo';

// various image files for each language

// domain ET, language ET
import deskR_ET_ET from '../assets/img/estonian_screens/ee_desk_r.png';
import deskS_ET_ET from '../assets/img/estonian_screens/ee_desk_s.png';
import mobR_ET_ET from '../assets/img/estonian_screens/ee_mob_r.png';
import mobS_ET_ET from '../assets/img/estonian_screens/ee_mob_s.png';

// domain ET, language RU
import deskR_ET_RU from '../assets/img/estonian_screens/ee_ru_desk_r.png';
import deskS_ET_RU from '../assets/img/estonian_screens/ee_ru_desk_s.png';
import mobR_ET_RU from '../assets/img/estonian_screens/ee_ru_mob_r.png';
import mobS_ET_RU from '../assets/img/estonian_screens/ee_ru_mob_s.png';

// domain LV, language LV
import deskR_LV_LV from '../assets/img/latvian_screens/lv_desk_r.png';
import deskS_LV_LV from '../assets/img/latvian_screens/lv_desk_s.png';
import mobR_LV_LV from '../assets/img/latvian_screens/lv_mob_r.png';
import mobS_LV_LV from '../assets/img/latvian_screens/lv_mob_s.png';

// domain LV, language RU
import deskR_LV_RU from '../assets/img/latvian_screens/lv_ru_desk_r.png';
import deskS_LV_RU from '../assets/img/latvian_screens/lv_ru_desk_s.png';
import mobR_LV_RU from '../assets/img/latvian_screens/lv_ru_mob_r.png';
import mobS_LV_RU from '../assets/img/latvian_screens/lv_ru_mob_s.png';

// domain LT, language LT
import deskR_LT_LT from '../assets/img/lithuanian_screens/lt_desk_r.png';
import deskS_LT_LT from '../assets/img/lithuanian_screens/lt_desk_s.png';
import mobR_LT_LT from '../assets/img/lithuanian_screens/lt_mob_r.png';
import mobS_LT_LT from '../assets/img/lithuanian_screens/lt_mob_s.png';
import VideoFilesFullLoop from "./VideoFilesFullLoop";
import MobileVideoButton from './MobileVideoButton';
import { trackPageView } from '../helpers/gaHelper';

const Question4 = () => {
   const { PUBLIC_URL, REACT_APP_LANGUAGE } = process.env;
  const {t} = useTranslation();
  const {addScore, language, trackGTMEvent} = useGame();

  useEffect(() => {
    trackPageView('/question/4');
  },[]);

  // wait
  async function wait(ms) {
    return new Promise(resolve => {
      setTimeout(resolve, ms);
    });
  }

  const [correctAreas, setCorrectAreas] = useState([]);
  const [wrongAreas, setWrongAreas] = useState([]);
  const [totalTries, setTotalTries] = useState(0);
  const [correctAnswers, setCorrectAnswers] = useState(0);
  const [scoreTier, setScoreTier] = useState(4);
  const [zoomedIn, setZoomedIn] = useState(false);

  // screens
  const [deskR, setDeskR] = useState(deskR_ET_ET);
  const [deskS, setDeskS] = useState(deskS_ET_ET);
  const [mobR, setMobR] = useState(mobR_ET_ET);
  const [mobS, setMobS] = useState(mobS_ET_ET);

  // classname for areas
  const [areaClassname, setAreaClassname] = useState('ee');

  const addBodyClass = className => document.body.classList.add(className);
  const removeBodyClass = className => document.body.classList.remove(className);

  // switch the image based on domain and language
  useEffect(() => {
    if (REACT_APP_LANGUAGE === 'et' && language === 'et') {
      setDeskR(deskR_ET_ET);
      setDeskS(deskS_ET_ET);
      setMobR(mobR_ET_ET);
      setMobS(mobS_ET_ET);
      setAreaClassname('ee');
    }
    if (REACT_APP_LANGUAGE === 'et' && language === 'ru') {
      setDeskR(deskR_ET_RU);
      setDeskS(deskS_ET_RU);
      setMobR(mobR_ET_RU);
      setMobS(mobS_ET_RU);
      setAreaClassname('ee-ru');
    }
    if (REACT_APP_LANGUAGE === 'lv' && language === 'lv') {
      setDeskR(deskR_LV_LV);
      setDeskS(deskS_LV_LV);
      setMobR(mobR_LV_LV);
      setMobS(mobS_LV_LV);
      setAreaClassname('lv');
    }
    if (REACT_APP_LANGUAGE === 'lv' && language === 'ru') {
      setDeskR(deskR_LV_RU);
      setDeskS(deskS_LV_RU);
      setMobR(mobR_LV_RU);
      setMobS(mobS_LV_RU);
      setAreaClassname('lv-ru');
    }
    if (REACT_APP_LANGUAGE === 'lt' && language === 'lt') {
      setDeskR(deskR_LT_LT);
      setDeskS(deskS_LT_LT);
      setMobR(mobR_LT_LT);
      setMobS(mobS_LT_LT);
      setAreaClassname('lt');
    }

  }, [REACT_APP_LANGUAGE, language]);

  useEffect(() => {
    if (zoomedIn) {
      addBodyClass('zoomed-open');
    } else {
      removeBodyClass('zoomed-open');
    }
  }, [zoomedIn]);

  useEffect(() => {
    const show = async () => {
      if (correctAnswers === 5 || totalTries === 7) {
        // calculate score
        let score = correctAnswers - (totalTries - 5);
        if (score < 1) {
          score = 1;
        }

        // calculate score tier
        let scoreTier = 4;
        if(totalTries === 5){
          scoreTier = 1;
        }
        if(totalTries === 6){
          scoreTier = 2;
        }
        if(totalTries === 7 && correctAnswers === 5){
          scoreTier = 3;
        }
        if(correctAnswers === 4){
          scoreTier = 3;
        }


        setScoreTier(scoreTier);

        addScore(score);

        // show the screen after 1 second
        await wait(1000);
        addBodyClass('fade-in-correct');

        return () => {
          removeBodyClass('fade-in-correct');
        };
      }
    };
    show();
  }, [correctAnswers, totalTries]);

  // attach the main.js file
  useEffect(() => {
    const script = document.createElement('script');
    script.src = `${PUBLIC_URL}/assets/js/main.js`;
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  // attach the jquery.nicescroll.min.js file
  useEffect(() => {
    const script = document.createElement('script');
    script.src = `${PUBLIC_URL}/assets/js/jquery.nicescroll.min.js`;
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  useEffect(() => {
    trackGTMEvent(4);
  }, []);

  const areaClick = (index) => {
    // 1 = URL
    // 2 = LOGO
    // 7 = ID-KAART
    // 10 = SISENEN button
    // 13 = BIT link on the right
    let correct = [1, 2, 5, 13, 14];
    let wrong = [3, 4, 6, 7, 8, 9, 10, 11, 12];

    if (REACT_APP_LANGUAGE === 'lv' && window.innerWidth > 600) {
      correct = [1, 2, 10, 13, 14];
      wrong = [3, 4, 6, 7, 8, 9, 11, 12];
    }

    if (correct.indexOf(index) > -1 && correctAreas.indexOf(index) === -1) {
      setCorrectAreas(prevState => [...prevState, index]);
      setCorrectAnswers(prev => prev + 1);
    }
    if (wrong.indexOf(index) > -1) {
      setWrongAreas(prevState => [...prevState, index]);
    }

    setTotalTries(prev => prev + 1);
  };

  const renderAreas = () => {
    const areas = [];

    for (let i = 1; i < 15; i++) {
      let className = `area area-${i} ${areaClassname}`;
      if (correctAreas.indexOf(i) > -1) {
        className += ' right';
      }
      if (wrongAreas.indexOf(i) > -1) {
        className += ' error';
      }
      areas.push(<div role='button' tabIndex={0} key={i} className={className} 
        onClick={() => areaClick(i)}
        onKeyDown={(evt) => {
          if (evt?.keyCode === 13 || evt?.keyCode === 32) {
            return  areaClick(i)
          }          
        }}
      />);
    }

    return areas;
  };

  return (
    <main>
      <section className="question q-4 type-3">
        <div className="inner">
          <ScoreBoard/>
          <ProgressBar question={4}/>
          <SecurityExpertQ4 text={t('questions.4.expert')} imageDesktop={deskR} imageMobile={mobR}/>

          <MobileVideoButton className="q4" />
          <VideoFilesFullLoop page='q4' id='q4-video'/>

          <div className="loop-screen q4" />
          <SkipVideo/>

          <div className="question-wrapper">

            <div className="wrap">

              <div className="image-container">
                <img src={deskS} alt=""/>
                <img className="mobile_scam" src={mobS} alt=""/>
                <div className="areas">
                  {renderAreas()}
                </div>
              </div>

              <div className="bottom-wrap">
                <div className={`choice-count ${zoomedIn ? 'bring-front' : ''}`}>
                  <div className="inner-wrap">
                    <span className="correct">{correctAreas.length}</span><span className="target">/5</span>
                  </div>
                </div>

                <h1>{t('questions.4.title')}</h1>
              </div>

              <div className="zoom" data-img={deskS}>
                <span role='button' tabIndex={0} className={`icon ${zoomedIn ? 'minus' : 'plus'}`}
                      onClick={() => setZoomedIn((zoomedIn) => !zoomedIn)}
                      onKeyDown={(evt) => {
                        if (evt?.keyCode === 13 || evt?.keyCode === 32) {
                          return setZoomedIn((zoomedIn) => !zoomedIn)
                        }
                      }}
                      />
              </div>
            </div>

            {zoomedIn && (
              <div className="zoomed-img">
                <img src={deskS} alt=""/>
                <div className="areas">
                  {renderAreas()}
                </div>
              </div>
            )}

          </div>

          {(correctAnswers === 5 || totalTries === 7) && (
            <CorrectAnswer question={4} isPlaying={true} scoreTier={scoreTier}/>
          )}

        </div>
      </section>
    </main>

  );

};

export default Question4;
